export const job_definitions_post_data = {
  filter: '',
  start_date: null,
  finish_date: null,
  include_archived: false,
  max_rows: 100,
  created_by: null,
};

export const job_definitions_query = {
  filter: '',
  start_date: null,
  finish_date: null,
  include_archived: false,
  max_rows: 100,
  created_by: null,
};
